import { Component, Input, output } from '@angular/core';

import type { User } from '@recruitee/account-types';
import { TranslatePipe } from '@recruitee/i18n';
import type { RequisitionFlow } from '@recruitee/requisitions-types';
import {
  BadgeComponent,
  BoxComponent,
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
} from '@recruitee/user-interface';

import { RequisitionsFlowStepsListContainerComponent } from '../../../containers/single-requisition/requisitions-flow-steps-list-container/requisitions-flow-steps-list-container.component';
import { FlowStepViewContext } from '../../../requisitions.types';

@Component({
  selector: 'rt-requisitions-approval-request-flow-preview',
  templateUrl: './approval-request-flow-preview.component.html',
  styleUrls: ['./approval-request-flow-preview.component.less'],
  imports: [
    BadgeComponent,
    BoxComponent,
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    DividerComponent,
    HeadingComponent,
    IconComponent,
    RequisitionsFlowStepsListContainerComponent,
    TranslatePipe,
  ],
})
export class ApprovalRequestFlowPreviewComponent {
  public readonly flowViewContext = FlowStepViewContext.Dialog;

  @Input() public flow: RequisitionFlow;
  @Input() public adminsMap: Record<number, User>;
  @Input() public departmentName: string | undefined;
  @Input() public isDepartmentsMode: boolean;

  public continue = output<void>();
  public cancel = output<void>();
}
